import createButtonLike from "../../components/Button/StandardButton/createButtonLike";
import Link from "../Link/Link";

const AnchorButton = createButtonLike(Link, "AnchorButton");

export default AnchorButton;
